import http from '@/services/http';

const products = {
  getProducts(params) {
    return http.request({
      method: 'get',
      url: '/ra-product',
      params,
    });
  },
  getProduct(id) {
    return http.request({
      method: 'get',
      url: `/ra-product/${id}`,
    });
  },
};

export default products;
